import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SearchResultsComponent } from './search-results.component';

import { ButtonModule } from '../../../button/button.module';
import { ScrollViewModule } from '../../../scroll-view/scroll-view.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { ListModule } from '../../../list/list.module';
import { LoadingPanelModule } from '../../../loading-panel/loading-panel.module';
import { LocalizationFilterFormModule } from './components/localization-filter-form/localization-filter-form.module';
import { EntityFilterFormModule } from './components/entity-filter-form/entity-filter-form.module';
import { EntityTypeFilterFormModule } from './components/entity-type-filter-form/entity-type-filter-form.module';
import { ObjectTypeFilterFormModule } from './components/object-type-filter-form/object-type-filter-form.module';
import { ObjectIdFilterFormModule } from './components/object-id-filter-form/object-id-filter-form.module';
import { AttributesFilterFormModule } from './components/attributes-filter-form/attributes-filter-form.module';
import { DeferRenderingModule } from 'app/shared/directives/defer-rendering/defer-rendering.module';
import { SaveFilterFormModule } from './components/save-filter-form/save-filter-form.module';
import { FilterHistoryModule } from './components/filter-history/filter-history.module';
import { ResultsTableViewModule } from './components/results-table-view/results-table-view.module';
import { ResultsChartViewModule } from './components/results-chart-view/results-chart-view.module';
import { ResultsStatisticsViewModule } from './components/results-statistics-view/results-statistics-view.module';
import { BlockModalDragModule } from 'app/shared/directives/block-modal-drag/block-modal-drag.module';
import { FloatingFilterModule } from './components/floating-filter/floating-filter.module';
import { PortalRenderModule } from 'app/shared/directives/portal-render/portal-render.module';
import { FilterTextModule } from './components/filter-text/filter-text.module';
import { IconicModule } from '../../../iconic/iconic.module';
import { ConfirmModalComponent } from '../../../confirm-modal/confirm-modal.component';

@NgModule({
  imports: [
    CommonModule,
    ResultsTableViewModule,
    ResultsChartViewModule,
    ResultsStatisticsViewModule,
    LocalizationFilterFormModule,
    EntityTypeFilterFormModule,
    EntityFilterFormModule,
    ObjectTypeFilterFormModule,
    AttributesFilterFormModule,
    ObjectIdFilterFormModule,
    SaveFilterFormModule,
    FilterHistoryModule,
    FloatingFilterModule,
    ButtonModule,
    IconicModule,
    TooltipModule,
    ScrollViewModule,
    ListModule,
    LoadingPanelModule,
    FilterTextModule,
    DeferRenderingModule,
    BlockModalDragModule,
    PortalRenderModule,
    ConfirmModalComponent,
  ],
  declarations: [SearchResultsComponent],
  exports: [SearchResultsComponent],
})
export class SearchResultsModule {}
